import SRTMElevation from './SRTMElevation';
import TerrainElevation from './TerrainElevation';
import { MAP_ID_ELEVATION } from "../../../store/MapContentsState";
// import LegendElevation from '../legend/LegendElevation';

class Elevation {
  static NAME = MAP_ID_ELEVATION;
  static ELEVATION_ELEVATION = 'Elevation';
  static ELEVATION_TERRAIN_ELEVATION = 'TerrainElevation';
  static CS_NAME = `CS_${Elevation.NAME}`;

  presetId = Elevation.CS_NAME;
  ready = false;

  constructor() {
    this.visible = false;
    this.srtmElevation = new SRTMElevation();
    this.terrainElevation = new TerrainElevation();
    this.srtmElevation.setVisible(true);
    this.terrainElevation.setVisible(true);
  }

  addObject() {
    return new Promise((resolve, reject) => {
      const promises = [];
      promises.push(this.srtmElevation.addObject());
      promises.push(this.terrainElevation.addObject());

      Promise.all(promises).then(() => {
        this.ready = true;
        resolve();
      });
    });
  }

  getDataName() {
    const dn1 = this.srtmElevation.getDataName();
    const dn2 = this.terrainElevation.getDataName();
    if (dn1 || dn2) {
      return [dn1, dn2];
    } else {
      return undefined;
    }
  }
  
  getDataHandler() {
    const h1 = this.srtmElevation.getDataHandler();
    const h2 = this.terrainElevation.getDataHandler();
    if (h1 || h2) {
      return [h1, h2];
    } else {
      return undefined;
    }
  }

  getDataReference() {
    const r1 = this.srtmElevation.getDataReference();
    const r2 = this.terrainElevation.getDataReference();
    if (r1 || r2) {
      return [r1, r2];
    } else {
      return undefined;
    }
  }

  getOpt() {
    return {
      ELEVATION: Object.assign(
        {
          Visible: this.isVisible()
        }, 
        this.srtmElevation.getOpt(), 
        this.terrainElevation.getOpt()
      )
    };
  }

  // getLegend() {
  //   return {
  //     id: Elevation.NAME,
  //     label: 'Elevation',
  //     component: LegendElevation,
  //     contents: this
  //   }
  // }

  getContentsVisibleState() {
    return [
      Elevation.ELEVATION_ELEVATION,
      Elevation.ELEVATION_TERRAIN_ELEVATION
    ].reduce((d, v) => {
      d[v] = this.getContents(v).isVisible()
      return d;
    }, {});
  }

  setContentsVisible(name, visible) {
    const contents = this.getContents(name);
    contents && contents.setVisible(visible);
  }

  setContentsSettings(param) {
    Object.keys(param).forEach(k => {
      this.setContentsVisible(k, param[k]);
    });
  }

  /**
   * 表示フラグを取得する.
   * @returns {boolean}
   */
  isVisible() {
    return this.visible;
  }

  /**
   * 表示フラグを設定する.
   * @param {boolean} visible 表示フラグ
   */
   setVisible(visible) {
    this.visible = visible;
  }

  
  /**
   * 描画の前処理が必要なコンテンツは継承先のクラスで実装する
   */
   beforeDraw() {
    this.srtmElevation.beforeDraw();
    this.terrainElevation.beforeDraw();
  }

  /**
   * 描画の後処理が必要なコンテンツは継承先のクラスで実装する
   */
  afterDraw() {
    this.srtmElevation.afterDraw();
    this.terrainElevation.afterDraw();
  }

  /**
   * 画角変更時の処理
   */
  updateBounds() {
    this.srtmElevation.updateBounds();
    this.terrainElevation.updateBounds();
  }

  getContents(name) {
    switch(name) {
      case Elevation.ELEVATION_ELEVATION:
        return this.srtmElevation;
      case Elevation.ELEVATION_TERRAIN_ELEVATION:
        return this.terrainElevation;
      default:
        return null;
    }
  }

  isReady() {
    return this.ready;
  }
}

export default Elevation;